export var ProfileQueryKey;
(function (ProfileQueryKey) {
    ProfileQueryKey["Profile"] = "Profile";
})(ProfileQueryKey || (ProfileQueryKey = {}));
